import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import "./index.css";
import CustomButton from '../generic-components/Button/Button';
import { useNavigate } from 'react-router-dom';

const Hero = ({
    title,
    titleAlign = 'left',
    subTitle,
    subTitleAlign = 'left',
    description, 
    descriptionAlign = 'left',
    primaryButton, 
    secondayButton, 
    backgroundImage,
    contentAlign = 'left'
}) => {

    const navigate = useNavigate()

    const handleNavigation = (route) => {
        if(route) {
            // Check if it's a hash route (starts with #)
            if(route.startsWith('#')) {
                const elementId = route.substring(1); // Remove the # symbol
                const element = document.getElementById(elementId);
                if(element) {
                    element.scrollIntoView({ 
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            } else {
                // Regular navigation
                navigate(route);
            }
        }
    };

    return (   

       <Box 
         className='hero-box' 
         style={{ backgroundImage }}
       >
        <Box className={`hero-box__inner ${contentAlign === 'center' ? 'center' : 'left'}`}>
            
            {title && (
                <Typography className={`hero-box__title ${titleAlign === 'center' ? 'center' : 'left'}`}>
                    {title}
                </Typography>
            )}

            {subTitle && (
                <Typography className={`hero-box__subTitle ${subTitleAlign === 'center' ? 'center' : 'left'}`}>
                    {subTitle}
                </Typography>
            )}

            {description && (
                <Typography className={`hero-box__description ${descriptionAlign === 'center' ? 'center' : 'left'}`}>
                    {description}
                </Typography>
            )}

            {(primaryButton || secondayButton) && (
                <Container 
                    disableGutters 
                    maxWidth={false} 
                    className={`hero-box__container ${contentAlign === 'center' ? 'center' : 'left'}`}
                    sx={contentAlign === 'center' ? { justifyContent: 'center' } : {}}
                >
                    {primaryButton && (
                        <CustomButton
                            className={primaryButton.className || 'hero-box__button'}
                            text={primaryButton.text || ''}
                            onClick = {()=>primaryButton.route ? 
                                handleNavigation(primaryButton.route) 
                                : primaryButton.onClick?.()
                            }
                        />
                    )}

                    {secondayButton && (
                        <CustomButton
                            className={secondayButton.className || 'hero-box__transparentButton'}
                            text={secondayButton.text || ''}
                            // onClick={secondayButton.onClick}
                            onClick = {()=>secondayButton.route ?
                                handleNavigation(secondayButton.route)
                                :secondayButton.onClick?.()
                            }
                        />
                    )}
                </Container>
            )}
        </Box>
       </Box>
    );
};

export default Hero;